// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

import { createElement, Translate, Paragraph, Button, Component } from '@plesk/ui-library';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PLESK_COOKIES } from './urls';

class Info extends Component {
    state = {
        isReady: false,
    };

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isReady: true });
        });
    }

    handleAcceptClick = () => {
        const { onSave, onPreferencesToggle } = this.props;
        onSave({ analytics: true, marketing: true });
        onPreferencesToggle(false);
    };

    handlePreferencesClick = () => {
        const { onPreferencesToggle } = this.props;
        onPreferencesToggle(true);
    };

    render() {
        const { contentAlignment } = this.props;
        const { isReady } = this.state;
        const namespace = 'info';

        return (
            <div
                className={classNames('cookie-policy-info', {
                    'cookie-policy-info--enter': isReady,
                    [`cookie-policy-info--${contentAlignment}`]: contentAlignment,
                })}
            >
                <div className="cookie-policy-info__inner">
                    <h3 className="cookie-policy-info__title">
                        <Translate content={`${namespace}.title`} />
                    </h3>
                    <Paragraph>
                        <Translate content={`${namespace}.necessaryCookiesMessage`} />
                    </Paragraph>
                    <Paragraph>
                        <Translate
                            content={`${namespace}.message`}
                            params={{
                                cookieInformationLink: (
                                    <a
                                        href={PLESK_COOKIES}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="cookie-policy-info__link"
                                    >
                                        <Translate content={`${namespace}.cookieInformationLink`} />
                                    </a>
                                ),
                            }}
                        />
                    </Paragraph>
                    <div className="cookie-policy-info__buttons">
                        <Button
                            className="cookie-policy-info__button"
                            data-type="cookie-policy-info-accept-button"
                            onClick={this.handleAcceptClick}
                        >
                            <Translate content={`${namespace}.acceptButton`} />
                        </Button>
                        <Button
                            className="cookie-policy-info__button"
                            data-type="cookie-policy-info-preferences-button"
                            onClick={this.handlePreferencesClick}
                        >
                            <Translate content={`${namespace}.preferencesButton`} />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

Info.propTypes = {
    onSave: PropTypes.func.isRequired,
    onPreferencesToggle: PropTypes.func.isRequired,
    contentAlignment: PropTypes.oneOf(['center']),
};

Info.defaultProps = {
    contentAlignment: undefined,
};

export default Info;



// WEBPACK FOOTER //
// ./app/cookie-policy/Info.js